import { createApiSlice } from "@common";
import {
  CRUD_CAMPAIGN,
  CRUD_CAMPAIGN_ALERT,
  CRUD_CAMPAIGN_BY_ID,
  CRUD_CAMPAIGN_BY_OWNER
} from "@routes";

const apiConfig = [
  {
    name: "addCampaign",
    method: "post",
    url: CRUD_CAMPAIGN,
    stateKey: "message",
  },
  {
    name: "getCampaign",
    method: "get",
    url: CRUD_CAMPAIGN,
    stateKey: "data",
  },
  {
    name: "getCampaignByOwner",
    method: "get",
    url: CRUD_CAMPAIGN_BY_OWNER,
    stateKey: "data",
  },
  {
    name: "updateCampaign",
    method: "put",
    url: CRUD_CAMPAIGN,
    stateKey: "message",
  },
  {
    name: "deleteCampaign",
    method: "delete",
    url: CRUD_CAMPAIGN,
    stateKey: "message",
  },
  {
    name: "campaignDeleteAlert",
    method: "get",
    url: CRUD_CAMPAIGN_ALERT,
    stateKey: "campaignAlertData",
  },
  {
    name: "getCampaignDetailsById",
    method: "get",
    url: CRUD_CAMPAIGN_BY_ID,
    stateKey: "details",
  },
];

const customReducers = {
  initialState: {
    data: [],
    details: [],
    campaignAlertData: [],
    additionalData: [],
  },
  reducers: {
    setAdditionalData: (state, action) => {
      state.additionalData = action.payload;
    },
  },
  extraReducers: {},
};

const { slice, thunks, actions } = createApiSlice(
  "campaign",
  apiConfig,
  customReducers,
);
const campaignSlice = slice;

export default campaignSlice.reducer;

export const {
  addCampaign,
  getCampaign,
  getCampaignByOwner,
  updateCampaign,
  deleteCampaign,
  campaignDeleteAlert,
  getCampaignDetailsById,
} = thunks;

export const { rowSelect } = actions;
